import script from "./GgmsFileUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsFileUpload.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsFileUpload.vue?vue&type=style&index=0&id=4a28bb2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a28bb2a"]])

export default __exports__